<template>
  <div class="circle-graph-container">
    <div class="information-container">
      <div class="information-title">Due Date performance</div>
      <div class="icon-container">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <img class="icon" v-bind="attrs" v-on="on" v-bind:src="require(`@/assets/icons/info.svg`)" alt="" />
          </template>
          <span>Percentage of projects on time versus all finished projects </span>
        </v-tooltip>
      </div>
    </div>
    <div class="graph-container">
    <div class="legend-container">
      <!-- <div class="legend-title">Priority:</div> -->
      <div class="legend-row">
        <div class="legend-item">
          <div style="--bullet-color: rgb(255, 102, 127)" class="custom-bullet"></div>
          <span>10+ days delay</span>
        </div>
        <div class="legend-item">
          <div style="--bullet-color: rgb(255, 210, 102)" class="custom-bullet"></div>
          <span>1-10 days delay</span>
        </div>
      </div>
      <div class="legend-row">
        <div class="legend-item">
          <div style="--bullet-color: rgb(108, 218, 102)" class="custom-bullet"></div>
          <span>0-10 days early</span>
        </div>
        <div class="legend-item">
          <div style="--bullet-color: rgb(102, 188, 255)" class="custom-bullet"></div>
          <span>10+ days early</span>
        </div>
      </div>
    </div>
      <svg class="graph" ref="svg" viewBox="0 0 300 300"></svg>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import { DueDateVisual } from "@/visualisation/dashboard/dueDateVisual.js";

export default {
  mounted() {
    this.svg = d3.select(this.$refs.svg);

    this.data = this.generateDummyData();

    this.initChart();
  },

  methods: {
    generateDummyData() {
      var data = [];

      data.push([8, 0, 2, 3]);
      for (var i = 0; i < 1000; i++) {
        var newData = [];
        for (var j = 0; j < 4; j++) {
          newData.push(Math.random() * 20);
        }
        data.push(newData);
      }

      return data;
    },
    getCurrentMetric() {
      var allData = this.$store.state.simulator.performanceTracker.metrics[this.$store.state.dashboard.slider];
      var pieData = [allData.finishedProjectsVeryLate, allData.finishedProjectsLittleLate, allData.finishedProjectsLittleOnTime, allData.finishedProjectsVeryOnTime]
      var currData = {finishedProjects: allData.finishedProjects, finishedOnTime: allData.finishedOnTime, pieData: pieData}
      return currData
    },
    initChart(){
      this.data = this.generateDummyData();
      var currData = this.getCurrentMetric();
      this.chart = new DueDateVisual(this.svg, currData);
    },
    updateChart() {
      var currData = this.getCurrentMetric();
      this.chart.updateChart(currData);
    },
  },
  data: () => ({
    data: null,
    arcs: null,
    arcTween: null,
    svg: null,
    arcSpacing: 0.02,
  }),
};
</script>

<style scoped>
.circle-graph-container {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
}

.graph-container {
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  overflow: hidden;
}

.information-container {
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  margin-left: 15px;
}

.custom-bullet {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--bullet-color, black); /* Default color is black */
  display: inline-block;
  margin-right: 5px;
}

.graph {
  position: relative;
  padding: 0;
  margin: 0;
  top: 0%;
  height: 80%;
  width: 100%;
}

.icon-container {
  margin-left: 10px;
  justify-content: center;
  align-items: center;

  display: flex;
  flex-direction: column;
}

.legend-item {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: rgba(128, 128, 128, 1);
  padding: 0px;
  padding-left: 10px;
  padding-right: 10px;
}

.legend-row {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  width: 100%;
}
.legend-information {
  display: flex;
  flex-direction: row;
}
.legend-container {
  position: relative;
  bottom: 1px;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  width: 100%;
  margin-top: 5px;
  min-height: 48px;
}

.icon {
  width: 20px;
  height: 20px;

  margin-top: 2px;
}

.legend-title {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: rgba(128, 128, 128, 1);
}

.information-title {
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  color: rgba(74, 74, 74, 1);
}
</style>
